import { RestSchemas } from '@/contexts/QueryProvider'

// Runtime constants with compile-time safety against RestSchemas numeric unions
export const AppSettingsType = {
  App: 1,
  Roles: 2,
  Teams: 3,
  Organisation: 4,
  TeamRoles: 5,
  EntityTypes: 6,
  FileTemplates: 7,
  FileTemplateRoles: 8,
  Glossary: 10,
  Faq: 11,
  ConfigSettings: 12,
  DataAssets: 15,
  DataAssetPermissions: 16,
  CollaborationChannels: 17,
  CollaborationChannelRoles: 18,
  Pipelines: 20,
  PipelinePermissions: 21,
  CustomMenus: 22,
} as const satisfies Record<string, RestSchemas['Messages.AppSettings.AppSettingsType']>

export const AppSettingsAction = {
  None: 0,
  Merge: 2,
  Replace: 3,
} as const satisfies Record<string, RestSchemas['Messages.AppSettings.AppSettingsAction']>

export type TAppSettingsType = (typeof AppSettingsType)[keyof typeof AppSettingsType]
export type TAppSettingsAction = (typeof AppSettingsAction)[keyof typeof AppSettingsAction]
